module.exports = __webpack_public_path__ + "static/img/tenor.db85ba0.gif";